import { AppTeamUtil } from '../../core/app-team-util';
import { MyCampApp } from '../common/enumerations';
import { NotificationEditModel } from './notification-edit.model';

import NotificationType = MyCampApp.NotificationType;
import RegistrationFilterType = MyCampApp.RegistrationFilterType;
import * as moment from 'moment/moment';

export class NotificationSendInfo
{
    Id: number = 0;
    NotificationId: number = 0;
    ScheduledDateTime!: Date;
    ScheduledDateTimeUTC?: Date;
    SentDateTime?: Date;
    SentDateTimeUTC?: Date;
    SentUserCount = 0;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            this.ScheduledDateTime = AppTeamUtil.convertApiDateStringToDate(json.ScheduledDateTime)!;
            this.ScheduledDateTimeUTC = json.ScheduledDateTimeUTC == null ? undefined : moment.utc(json.ScheduledDateTimeUTC).toDate();
            this.SentDateTime = json.SentDateTime == null ? undefined : AppTeamUtil.convertApiDateStringToDate(json.SentDateTime)!;
            this.SentDateTimeUTC = json.SentDateTimeUTC == null ? undefined : moment.utc(json.SentDateTimeUTC).toDate();
        }
    }

    get IsPublished(): boolean { return this.SentDateTime != null; }

    static typeFromString(str: string): NotificationType
    {
        return str.toString() === '1' ? NotificationType.Email : str.toString() === '2' ? NotificationType.Push : NotificationType.Sms;
    }

    static htmlTextFromString(str: string): string
    {
        if (str == undefined || str.length === 0) return '';
        const lines: string[] = str.split('\n');
        const htmlLines = lines.map(line => `<p>${line}</p>`);
        return htmlLines.join('');
    }
}
